

























import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { Order } from "@/models/order/order";

/**
 * FUPOF-191 (decision D7): persistent banner shown while the store holds a
 * pre-saved draft or a submitted quote being edited, so the user always
 * knows what they're working on.
 */
@Component
export default class EditModeBanner extends Vue {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;

  get visible(): boolean {
    // Post-submit the store still holds draft_id until Submitted.vue's mounted
    // hook clears the order; hide here so the banner never flashes on the
    // confirmation page. Auth pages are excluded by the isLoggedIn gate in App.vue.
    if (this.$route?.name === "Submitted") return false;
    return !!this.storeOrder.draft_id;
  }

  /** The NetSuite link, not draft_status, is what makes a quote authoritative
   * in NetSuite and therefore submit-only to persist. */
  get isNetSuiteLinked(): boolean {
    return !!this.storeOrder.netsuite_id;
  }

  /** How NetSuite itself names the quote: the document number ("QUO2400").
   * Falls back to the internal id if the document number wasn't carried over. */
  get quoteRef(): string {
    return (
      this.storeOrder.netsuite_tran_id || `NetSuite #${this.storeOrder.netsuite_id}`
    );
  }

  get quoteLabel(): string {
    const name = this.storeOrder.contact_details?.quote_name;
    if (this.isNetSuiteLinked) {
      return name ? `${name} (${this.quoteRef})` : this.quoteRef;
    }
    return name || `#${this.storeOrder.draft_id}`;
  }
}
